import styled from "styled-components";

export const PrivilegeWidgetStyled = styled.div`
  .Privilege_header {
    margin-bottom: 30px;
    .Privilege_text {
      margin-bottom: 2px;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.PURPLE_11};
      font-size: ${({ theme }) => theme.FONT.SIZE.S26};
      font-family: ${({ theme }) =>
        theme.FONT.STYLE.GT_AMERICA_COMPRESSED_BOLD};
    }
    .liner {
      margin: auto;
      border-top: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
      width: 50px;
    }
  }
  .Privilege_list {
    margin: auto;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;
    .privilege_item {
      flex-basis: calc(25% - 15px);
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.IPAD}) {
    .Privilege_list {
      gap: 16px;
      .privilege_item {
        flex-basis: calc(50% - 10px);
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .Privilege_list {
      gap: 20px;
      .privilege_item {
        flex-basis: 100%;
      }
    }
  }
`;
